export default __webpack_public_path__ + "static/media/Djeco-Clipaclip-1.b7500443.jpg";